<div class="calendar-page">
  <div class="calendar-layout">
    <!-- Oldalsáv: szűrők -->
    <aside class="calendar-sidebar">
      <div class="sidebar-header">
        <h3 class="sidebar-title">Szűrők</h3>
        <button
          mat-icon-button
          [matMenuTriggerFor]="settingsMenu"
          matTooltip="Naptár beállítások">
          <mat-icon>settings</mat-icon>
        </button>
        <mat-menu #settingsMenu="matMenu">
          <div class="settings-menu-content" (click)="$event.stopPropagation()">
            <h4 class="settings-label">Időrács felbontás</h4>
            <mat-radio-group
              [(ngModel)]="slotDuration"
              (change)="onSlotDurationChange()">
              <mat-radio-button value="00:15:00">15 perc</mat-radio-button>
              <mat-radio-button value="00:20:00">20 perc</mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-menu>
      </div>

      <!-- Eseménytípus szűrő -->
      <div class="filter-section">
        <h4 class="filter-label">Eseménytípus</h4>
        <mat-checkbox
          [(ngModel)]="showAppointments"
          (change)="onFilterChange()"
          color="primary">
          <span class="event-dot" style="background: #1976D2"></span>
          Időpontok
        </mat-checkbox>
        <mat-checkbox
          [(ngModel)]="showReminders"
          (change)="onFilterChange()"
          color="accent">
          <span class="event-dot" style="background: #FFC107"></span>
          Emlékeztetők
        </mat-checkbox>
      </div>

      <!-- Más felhasználók naptárjai -->
      @if (visibleUsers.length > 0) {
        <div class="filter-section">
          <h4 class="filter-label">Naptárak</h4>
          @for (user of visibleUsers; track user.user_id; let i = $index) {
            <mat-checkbox
                [checked]="selectedUserIds.has(user.user_id)"
                (change)="onUserToggle(user.user_id, $event.checked)"
                color="primary">
                <span class="event-dot" [style.background]="getUserColor(i)"></span>
                {{ user.fullname }}
              </mat-checkbox>
            }
          </div>
        }

        <!-- Admin: Láthatóság kezelés gomb -->
        @if (isManagerOrAdmin) {
          <div class="filter-section">
            <button
              mat-stroked-button
              (click)="openVisibilityDialog()"
              matTooltip="Naptár-láthatóság kezelése">
              <mat-icon>settings</mat-icon>
              Láthatóság
            </button>
          </div>
        }
      </aside>

      <!-- Fő terület: naptár -->
      <main class="calendar-main">
        <!-- Betöltés jelző -->
        @if (isLoading) {
          <div class="calendar-loading-overlay">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
        }

        <app-calendar-view
          [events]="calendarEvents"
          [slotDuration]="slotDuration"
          (dateSelect)="onDateSelect($event)"
          (eventClick)="onEventClick($event)"
          (eventDrop)="onEventDrop($event)"
          (eventResize)="onEventResize($event)"
          (datesSet)="onDatesSet($event)">
        </app-calendar-view>
      </main>
    </div>
</div>
